import OregonCityPageTemplate from "@/pages/oregon-city/CityPageTemplate";
import { portlandConfig } from "./data";

export default function PortlandPage() {
  return <OregonCityPageTemplate config={portlandConfig} />;
}